import type { StylesMap } from 'Types';

const GestureHandlerStyles: StylesMap = {
    container: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: 100
    }
};

export default GestureHandlerStyles;
